<template>
    <Divider :align="contentPosition" :layout="direction" :type="type" style="width: auto">
        <slot></slot>
    </Divider>
</template>

<script>
import Divider from 'primevue/divider';

export default {
    name: 'tw-divider',
    components: {
        Divider
    },
    props: {
        direction: String,
        contentPosition: String,
        type: String
    }
}
</script>
